/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import { action, computed } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { service } from '@ember/service';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import ENV from '../../../config/environment';

export default class ApplyTemplatesController extends Controller {
  @service
  fetch;

  @service
  paperToaster;

  @tracked
  selectedTemplates = {};
  selectedTemplateIds = [];

  @tracked
  inProgress = false;

  @tracked
  selectedSchool;

  @action
  setSelectedSchool(value) {
    this.selectedSchool = value;
  }

  @computed('model.templates.[]')
  get studentTemplates() {
    return this.get('model.templates').filter(
      (t) => t.personType === PersonType.LEARNER,
    );
  }

  @computed('model.templates.[]')
  get staffTemplates() {
    return this.get('model.templates').filter(
      (t) => t.personType === PersonType.STAFF,
    );
  }

  @computed('model.templates.[]')
  get caregiverTemplates() {
    return this.get('model.templates').filter(
      (t) => t.personType === PersonType.CAREGIVER,
    );
  }

  @computed('model.templates.[]')
  get medicalTemplates() {
    return this.get('model.templates').filter(
      (t) => t.personType === PersonType.DOCTORS_AND_SPECIALISTS,
    );
  }

  @action
  toggleChecked(templateId) {
    let selected = !this.selectedTemplates[templateId];
    this.selectedTemplates = {
      ...this.selectedTemplates,
      [templateId]: selected,
    };
    if (selected) {
      this.selectedTemplateIds = [...this.selectedTemplateIds, templateId];
    } else {
      this.selectedTemplateIds = this.selectedTemplateIds.filter(
        (id) => id !== templateId,
      );
    }
  }

  @action
  apply() {
    let toaster = this.paperToaster;
    this.inProgress = true;

    this.fetch
      .post(ENV.APP.apiHost + '/people-schema/v4/templates/sets:apply', {
        dataType: 'json',
        data: JSON.stringify({
          schoolId: this.get('selectedSchool.id'),
          setIds: this.selectedTemplateIds,
        }),
      })
      .then(() => {
        toaster.show('Templates applied!', {
          duration: 4000,
          position: 'top right',
        });
      })
      .catch(() => {
        toaster.show('Failed to apply template!', {
          duration: 40000,
          position: 'top right',
        });
      })
      .then(() => {
        this.inProgress = false;
      });
  }
}
